import { Component } from 'react';
import {
    Tabs, Tab, IconButton, Tooltip, Box, Typography, FormControlLabel, Checkbox, Button,
    Autocomplete,
    TextField
} from "@mui/material";
import './CommonTabs.css';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { clearCachevalue, getCachevalue, localGetItem, setCachevalue } from '../../Utility/Services/CacheProviderService';
import { AmountFormat, CheckAccessFunc } from '../CommonFunctions/CommonFunctions';
import CommonDatePicker from './CommonDatePicker';
import { filterMenuBySubscription } from "../../Utility/AccessUtils";
import { ImagePaths } from '../../Utility/ImagePaths';
export default class CommonTabs extends Component {
    constructor(props) {
        super(props);
        const filteredList = filterMenuBySubscription(props.List, props.subscriptionData, props.role) || [];
        const findSelectionFromFiltered = (selTab) => {
            if (!selTab) return null;
            // check main tabs
            let item = filteredList.find(it => it.id === selTab.id);
            if (item) {
                // if selTab refers to a main tab
                const sub = item.subMenu && item.subMenu.length ? item.subMenu[0] : null;
                return { item, sub };
            }
            // search submenus
            for (let it of filteredList) {
                const sub = (it.subMenu || []).find(sm => sm.id === selTab.id);
                if (sub) return { item: it, sub };
            }
            return null;
        };

        const initialSelection = findSelectionFromFiltered(props.selectedTab)
            || (filteredList[0] ? { item: filteredList[0], sub: (filteredList[0].subMenu && filteredList[0].subMenu[0]) || null } : { item: null, sub: null });

        this.state = {
            MainTabIndex: initialSelection.item ? initialSelection.item?.id : null,
            SubTabIndex: initialSelection.sub ? initialSelection.sub.id : 0,
            List: filteredList,
            SelectedItem: initialSelection.item,
            SelectedSubItem: initialSelection.sub,
            BackScreen: props.BackToHome ? props.BackToHome : null,
            isSubRendered: false,
            forcancel: false,
            isBillDoctor: JSON.parse(localGetItem("loggedInUserInfo"))?.bill_doctor_enabled ? true : false,
            ConsultantDataList: JSON.parse(localGetItem("DoctorsList")) ? JSON.parse(localGetItem("DoctorsList")) : [],
            consultantName: null,
            loginInfo: null
        }
    }

    componentDidMount() {
        var props = this.props
        let loginInfo = localGetItem('loggedInUserInfo')
        console.log("CommonTabs mounted with props:", props);
        const filteredList = filterMenuBySubscription(props.List, props.subscriptionData, props.role) || [];

        const findSelectionFromFiltered = (selTab) => {
            if (!selTab) return null;
            let item = filteredList.find(it => it.id === selTab.id);
            if (item) return { item, sub: (item.subMenu && item.subMenu[0]) || null };
            for (let it of filteredList) {
                const sub = (it.subMenu || []).find(sm => sm.id === selTab.id);
                if (sub) return { item: it, sub };
            }
            return null;
        };

        const initialSelection = findSelectionFromFiltered(props.selectedTab)
            || (filteredList[0] ? { item: filteredList[0], sub: (filteredList[0].subMenu && filteredList[0].subMenu[0]) || null } : { item: null, sub: null });

        console.log("Filtered tabs:", filteredList);
        console.log("Initial selection:", initialSelection);

        // Debug the access control for IP Order path (remove when not needed)
        // debugPathAccess(props.subscriptionData, props.role, "/IPHome/PatientDetails/CreateOrder");

        this.setState({
            List: filteredList,
            SelectedItem: initialSelection.item,
            MainTabIndex: initialSelection.item ? initialSelection.item.id : null,
            BackScreen: props.BackToHome ? props.BackToHome : null,
            SubTabIndex: initialSelection.sub ? initialSelection.sub.id : 0,
            SelectedSubItem: initialSelection.sub,
            forcancel: this.props.history?.location?.state?.isCancelBillFetched ? true : false,
            loginInfo: JSON.parse(loginInfo)
        }, () => {
            if (this.state.SubTabIndex == 6.21 && !this.state.forcancel && this.state.isBillDoctor) {
                let patientData = getCachevalue("IppatientData")
                let doctorID = patientData ? JSON.parse(patientData)?.doctor_id : null
                let selectedDoc = this.state.ConsultantDataList?.find((item) => item?.doctor_id === doctorID)
                this.setState({ consultantName: selectedDoc ? selectedDoc : null })
            }
        })
    }

    // componentDidUpdate(prevProps) {
    //     var props = this.props
    //     if (prevProps !== this.props && this.props) {
    //         if ((prevProps.selectedTab?.id != this.props.selectedTab?.id) || this.props?.history?.location?.state?.Reset) {
    //             this.setState({
    //                 forcancel: (this.props.history?.location?.state?.isCancelBillFetched) ? true : false,
    //                 List: filteredList || [],
    //                 SelectedItem: this.props.selectedTab ? this.props.selectedTab : this.props.List[0],
    //                 MainTabIndex: this.props.selectedTab ? this.props.selectedTab?.id : this.props.List[0]?.id,
    //                 BackScreen: this.props.BackToHome ? this.props.BackToHome : null,
    //                 SubTabIndex: this.props.selectedTab ? (this.props.selectedTab?.subMenu.length !== 0 ? this.props.selectedTab?.subMenu[0]?.id : 0) : 0,
    //                 SelectedSubItem: this.props.selectedTab ? (this.props.selectedTab?.subMenu.length > 0 ? this.props.selectedTab?.subMenu[0] : null) : null,
    //             }, () => {
    //                 if (this.state.SubTabIndex == 6.21 && this.state.isBillDoctor) {
    //                     let patientData = getCachevalue("IppatientData")
    //                     let doctorID = patientData ? JSON.parse(patientData)?.doctor_id : null
    //                     let selectedDoc = this.state.ConsultantDataList?.find((item) => item?.doctor_id === doctorID)
    //                     this.setState({ consultantName: selectedDoc ? selectedDoc : null })
    //                 }
    //             })
    //         } else {
    //             this.setState({
    //                 forcancel: (this.props.history?.location?.state?.isCancelBillFetched) ? true : false,
    //                 List: filteredList || [],
    //                 SelectedItem: this.props.selectedTab ? this.props.selectedTab : this.props.List[0],
    //                 MainTabIndex: this.props.selectedTab ? this.props.selectedTab?.id : this.props.List[0]?.id,
    //                 BackScreen: this.props.BackToHome ? this.props.BackToHome : null,
    //                 SubTabIndex: this.state.SubTabIndex ? this.state.SubTabIndex : (this.props.selectedTab?.subMenu.length !== 0 ? this.props.selectedTab?.subMenu[0]?.id : 0),
    //                 SelectedSubItem: this.state.SubTabIndex ? this.state.SelectedSubItem : (this.props.selectedTab?.subMenu.length > 0 ? this.props.selectedTab?.subMenu[0] : null),
    //             }, () => {
    //                 if (this.state.SubTabIndex == 6.21 && this.state.isBillDoctor) {
    //                     let patientData = getCachevalue("IppatientData")
    //                     let doctorID = this.props.billDocId ? this.props.billDocId : patientData ? JSON.parse(patientData)?.doctor_id : null
    //                     let selectedDoc = this.state.ConsultantDataList?.find((item) => item?.doctor_id === doctorID)
    //                     this.setState({ consultantName: selectedDoc ? selectedDoc : null })
    //                 }
    //             })
    //         }
    //     }
    // }

    componentDidUpdate(prevProps) {
        const props = this.props;

        // detect relevant changes
        const listChanged = prevProps.List !== props.List;
        const subsChanged = prevProps.subscriptionData !== props.subscriptionData;
        const roleChanged = prevProps.role !== props.role;
        const selectedTabChanged = (prevProps.selectedTab?.id || null) !== (props.selectedTab?.id || null);

        // handle Reset flag in history state (guarded)
        const prevReset = prevProps?.history?.location?.state?.Reset;
        const currReset = props?.history?.location?.state?.Reset;
        const resetChanged = prevReset !== currReset;

        // Also react if cancel-bill state changed (you used this earlier)
        const prevCancel = !!prevProps?.history?.location?.state?.isCancelBillFetched;
        const currCancel = !!props?.history?.location?.state?.isCancelBillFetched;
        const cancelChanged = prevCancel !== currCancel;

        // Only recompute when something relevant changed
        if (!(listChanged || subsChanged || roleChanged || selectedTabChanged || resetChanged || cancelChanged)) {
            return;
        }

        // Rebuild filtered list from new props
        const filteredList = filterMenuBySubscription(props.List, props.subscriptionData, props.role) || [];

        // helper to find selection by id inside filtered list
        const findInFiltered = (id) => {
            if (!id) return null;
            // find main tab
            const main = filteredList.find(it => it.id === id);
            if (main) return { item: main, sub: (main.subMenu && main.subMenu.length ? main.subMenu[0] : null) };
            // find sub tab
            for (let it of filteredList) {
                const s = (it.subMenu || []).find(sm => sm.id === id);
                if (s) return { item: it, sub: s };
            }
            return null;
        };

        // Decide selection based on priority:
        // 1) If Reset flag is present and true -> try props.selectedTab first, else fallback to first filtered item
        // 2) Else if props.selectedTab changed -> pick props.selectedTab (if available in filteredList)
        // 3) Else try to preserve current selection (state) by finding it in new filteredList
        // 4) Finally fallback to first filtered item (if any)
        let selection = null;

        if (currReset) {
            // Reset requested: try to use provided selectedTab, otherwise choose first
            selection = findInFiltered(props.selectedTab?.id) || (filteredList[0] ? { item: filteredList[0], sub: (filteredList[0].subMenu?.[0] || null) } : null);
        } else if (selectedTabChanged && props.selectedTab?.id) {
            selection = findInFiltered(props.selectedTab.id);
        }

        if (!selection) {
            // try preserve prior selection (prefer sub selection)
            selection = findInFiltered(this.state.SelectedSubItem?.id) || findInFiltered(this.state.SelectedItem?.id);
        }

        if (!selection && filteredList.length) {
            selection = { item: filteredList[0], sub: (filteredList[0].subMenu?.[0] || null) };
        }

        // Build nextState and only set if changed
        const nextSelectedItem = selection ? selection.item : null;
        const nextSelectedSubItem = selection ? selection.sub : null;
        const nextMainTabIndex = nextSelectedItem ? nextSelectedItem.id : null;
        const nextSubTabIndex = nextSelectedSubItem ? nextSelectedSubItem.id : 0;
        const nextForCancel = currCancel;
        const nextBackScreen = props.BackToHome || null;

        const needUpdate =
            // if filteredList reference changed OR sizes differ (quick check)
            this.state.List !== filteredList ||
            (this.state.SelectedItem?.id || null) !== (nextSelectedItem?.id || null) ||
            (this.state.SelectedSubItem?.id || null) !== (nextSelectedSubItem?.id || null) ||
            this.state.MainTabIndex !== nextMainTabIndex ||
            this.state.SubTabIndex !== nextSubTabIndex ||
            this.state.forcancel !== nextForCancel ||
            this.state.BackScreen !== nextBackScreen;

        if (needUpdate) {
            this.setState({
                List: filteredList,
                SelectedItem: nextSelectedItem,
                SelectedSubItem: nextSelectedSubItem,
                MainTabIndex: nextMainTabIndex,
                SubTabIndex: nextSubTabIndex,
                forcancel: nextForCancel,
                BackScreen: nextBackScreen
            }, () => {
                // preserve existing consultant logic (if you need to recompute consultantName)
                if (this.state.SubTabIndex == 6.21 && this.state.isBillDoctor) {
                    let patientData = getCachevalue("IppatientData");
                    let doctorID = this.props.billDocId ? this.props.billDocId : (patientData ? JSON.parse(patientData)?.doctor_id : null);
                    let selectedDoc = this.state.ConsultantDataList?.find((item) => item?.doctor_id === doctorID);
                    if (selectedDoc) {
                        this.setState({ consultantName: selectedDoc });
                    } else {
                        this.setState({ consultantName: null });
                    }
                }
            });
        }
    }

    handleChange = (event, newValue) => {
        const selected = this.state.List.find(item => item.id == newValue);
        const firstSub = selected?.subMenu?.length ? selected.subMenu[0] : null;

        // Debug the access control for the selected main tab (remove when not needed)
        // if (selected && selected.path) {
        //     debugPathAccess(this.props.subscriptionData, this.props.role, selected.path);
        // }

        this.setState({
            MainTabIndex: newValue,
            SelectedItem: selected,
            SelectedSubItem: firstSub,
            SubTabIndex: firstSub ? firstSub.id : 0
        }, () => {
            if (getCachevalue('CurrentDoctorPatientData')) {
                setCachevalue(getCachevalue('CurrentDoctorPatientData'), "DoctorPatientData")
                clearCachevalue("CurrentDoctorPatientData");
            }
            if (getCachevalue('bill_doctor_id')) {
                clearCachevalue("bill_doctor_id")
            }
            let { history } = this.props
            // history.push({ pathname: `${this.state.SelectedItem.path}` })
            if (selected?.path) history.push({ pathname: `${selected.path}` });
        })

    };
    handleChangesub = (event, newValue) => {
        if (getCachevalue('bill_doctor_id')) {
            clearCachevalue("bill_doctor_id")
        }
        const sub = this.state.SelectedItem?.subMenu?.find(item => item.id == newValue) || null;

        // Debug the access control for the selected sub tab (remove when not needed)
        // if (sub && sub.path) {
        //     debugPathAccess(this.props.subscriptionData, this.props.role, sub.path);
        // }

        this.setState({
            SubTabIndex: newValue,
            SelectedSubItem: sub
        })
    };

    checkAccess = (data) => {
        try {
            let patientDatas = getCachevalue("patientData")
            let patients = JSON.parse(patientDatas)
            var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
            var UserData = myUser
            if (data.menuName === "Nurse Notes" && UserData?.module_name === "front_office") {
                if (patients?.appointment_id) { return true } else { return false }
            } else if (data.menuName === "Service Billing" || data.menuName === "Room Change" || data.menuName === "Receive Payment") {
                if (UserData?.module_name !== "nurse") { return true } else { return false }
            }
            // else if (data.menuName === "Billing") {
            //     if ((UserData?.module_name !== "nurse" && patients?.appointment_id) || (UserData?.module_name === "ot_management") || (UserData?.module_name === 'Doctor')) { return true } else { return false }
            // }
            else if (data.menuName === 'No Show Report') {
                if (localGetItem("noShowStatus") === "true") { return true } else { return false }
            }
            else {
                return true
            }
        }
        catch (e) {
            console.log(e?.message)
            return true
        }
    }

    SubTabcheckAccess = (data) => {
        try {
            var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
            var UserData = myUser
            if (data.menuName === "Doctor Notes" || data.menuName === "IV / IM Track" || data.menuName === "Pain Chart" || data.menuName === "Medication" || data.menuName === "Laboratory") {
                if (UserData?.module_name !== "nurse") { return true } else { return false }
            }
            else {
                return true
            }
        }
        catch (e) {
            return true
        }
    }

    FilterDate = (from, to, index) => {
        this.props.receiveDateChange(from, to, index)
    }

    // renderMainComponent = (data, Type) => {
    //     if (data?.Access?.viewAccess === true) {
    //         return data?.component
    //     }
    //     else if (data?.Access?.viewAccess === false) {
    //         return <Typography className='eMed_NoAccess_Text' sx={{ paddingTop: Type === "Tab" ? "15.65vw" : "13vw" }}>No Access For This Screen</Typography>
    //     } else {
    //         return data?.component
    //     }
    // }

    renderMainComponent = (data, Type) => {
        const { role, showLockPopup } = this.props;

        if (!data) {
            return <Typography className='eMed_NoAccess_Text' sx={{ paddingTop: Type === "Tab" ? "15.65vw" : "13vw" }}>No Screen Selected</Typography>;
        }

        const isLocked = !!data.is_locked;

        // For admin users: check is_locked FIRST before checking Access.viewAccess
        // Admin subscription data only has is_locked (no viewAccess), so locked tabs should show lock screen
        if (role === "admin" && isLocked) {
            if (typeof showLockPopup === 'function') showLockPopup(data.menuName);
            return <Box className="eMed_NoAccess_Text" sx={{ paddingTop: '5vw', marginLeft: "-40vw", textAlign: 'center' }}>
                <img src={ImagePaths.LockScreen.default} alt="Lock" />
                <Typography sx={{ marginTop: '1vw', fontSize: '1.2vw', fontWeight: 600 }}>This feature is locked.</Typography>
            </Box>;
        }

        // For non-admin users: check Access.viewAccess first
        // This handles cases where Access property grants access but subscription data marks it as locked
        if (data.Access && data.Access.viewAccess === true) {
            return data?.component || null;
        }
        
        // Note: Access check is now handled by filterMenuBySubscription
        // Tabs that pass the filter should be shown - this legacy check is removed
        // to support tabs not defined in package structure (which should be visible by default)

        if (role === "user" && isLocked) {
            // User should not reach here normally because filter removes locked items,
            // but guard anyway
            return <Typography className='eMed_NoAccess_Text' sx={{ paddingTop: Type === "Tab" ? "15.65vw" : "13vw" }}>No Access For This Screen</Typography>;
        }

        // safe return of component (or null if missing)
        return data?.component || null;
    };

    returnBackButtonName = () => {
        if (getCachevalue("OPCancelBilldata") || getCachevalue("IPCancelBilldata") || getCachevalue('RadCancelBillData')) {
            let CancelBillData = getCachevalue("OPCancelBilldata") ? JSON.parse(getCachevalue("OPCancelBilldata")) : JSON.parse(getCachevalue("IPCancelBilldata")) ? JSON.parse(getCachevalue("IPCancelBilldata")) : JSON.parse(getCachevalue("RadCancelBillData"))
            if (CancelBillData?.FromBills) {
                return "Back to bills"
            } else {
                return "Back to Overall bills"
            }
        } else if (getCachevalue("LabCancelBilldata")) {
            let CancelBillData = JSON.parse(getCachevalue("LabCancelBilldata"))
            if (CancelBillData?.FromBills) {
                return "Back to bills"
            } else if (CancelBillData?.FromStatus) {
                return "Back to Home"
            } else {
                return "Back to Overall bills"
            }
        }
    }

    CancellBackButton = () => {
        let { history } = this.props
        return (
            <Button
                startIcon={<ChevronLeftIcon />}
                size='small'
                variant='contained'
                sx={{ textTransform: 'capitalize', }}
                emed_tid="common_tabs_cancel_back_btn"
                onClick={() => {
                    if (getCachevalue("OPCancelBilldata")) {
                        let CancelBillData = JSON.parse(getCachevalue("OPCancelBilldata"))
                        if (CancelBillData?.FromBills) {
                            clearCachevalue("OPCancelBilldata");
                            clearCachevalue("isForCancelBill");
                            this.props.changeScreen()
                            this.setState({
                                MainTabIndex: 1.2,
                                SelectedItem: this.state.List.filter((item) => item.id == 1.2)[0],
                            }, () => {
                                setTimeout(() => {
                                    this.setState({
                                        SubTabIndex: 1.23,
                                        SelectedSubItem: this.state.SelectedItem.subMenu.filter((item) => item.id == 1.23)[0]
                                    })
                                }, 500)
                            })
                        } else {
                            clearCachevalue("OPCancelBilldata");
                            clearCachevalue("isForCancelBill");
                            history.push({ pathname: '/BillingTransaction/OverAllBills' })
                        }
                    } else if (getCachevalue("IPCancelBilldata")) {
                        let CancelBillData = JSON.parse(getCachevalue("IPCancelBilldata"))
                        if (this.props.billDocId) {
                            this.props.removeBillDoc()
                        }
                        if (CancelBillData?.FromBills) {
                            clearCachevalue("IPCancelBilldata");
                            clearCachevalue("isForCancelBill");
                            this.props.changeScreen()
                            this.setState({
                                MainTabIndex: 6.2,
                                SelectedItem: this.state.List.filter((item) => item.id == 6.2)[0],
                            }, () => {
                                setTimeout(() => {
                                    this.setState({
                                        SubTabIndex: 6.23,
                                        SelectedSubItem: this.state.SelectedItem.subMenu.filter((item) => item.id == 6.23)[0]
                                    })
                                }, 500)
                            })
                        } else {
                            clearCachevalue("IPCancelBilldata");
                            clearCachevalue("isForCancelBill");
                            history.push({ pathname: '/BillingTransaction/OverAllBills' })
                        }
                    } else if (getCachevalue("LabCancelBilldata")) {
                        let CancelBillData = JSON.parse(getCachevalue("LabCancelBilldata"))
                        if (CancelBillData?.FromBills) {
                            clearCachevalue("LabCancelBilldata");
                            clearCachevalue("isForCancelBill");
                            if (getCachevalue("patientData")) {
                                this.props.changeScreen()
                                history.push({ pathname: '/OPHome/PatientDetails/Billing' })
                                this.setState({
                                    MainTabIndex: 1.2,
                                    SelectedItem: this.state.List.filter((item) => item.id == 1.2)[0],
                                }, () => {
                                    setTimeout(() => {
                                        this.setState({
                                            SubTabIndex: 1.23,
                                            SelectedSubItem: this.state.SelectedItem.subMenu.filter((item) => item.id == 1.23)[0]
                                        })
                                    }, 500)
                                })
                            } else {
                                this.props.changeScreen()
                                history.push({ pathname: '/IPHome/PatientDetails/ServiceBilling' })
                                this.setState({
                                    MainTabIndex: 6.2,
                                    SelectedItem: this.state.List.filter((item) => item.id == 6.2)[0],
                                }, () => {
                                    setTimeout(() => {
                                        this.setState({
                                            SubTabIndex: 6.23,
                                            SelectedSubItem: this.state.SelectedItem.subMenu.filter((item) => item.id == 6.23)[0]
                                        })
                                    }, 500)
                                })
                            }
                        } else if (CancelBillData?.FromStatus) {
                            clearCachevalue("LabCancelBilldata");
                            clearCachevalue("isForCancelBill");
                            this.props.changeScreen()
                            history.push({ pathname: '/MainHome' })
                        } else {
                            clearCachevalue("LabCancelBilldata");
                            clearCachevalue("isForCancelBill");
                            history.push({ pathname: '/BillingTransaction/OverAllBills' })
                        }
                    } else if (getCachevalue("RadCancelBillData")) {
                        let CancelBillData = JSON.parse(getCachevalue("RadCancelBillData"))
                        if (JSON.parse(localGetItem("loggedInUserInfo"))?.module_name === "front_office") {
                            if (CancelBillData?.FromBills) {
                                clearCachevalue("LabCancelBilldata");
                                clearCachevalue("isForCancelBill");
                                clearCachevalue("RadCancelBillData");
                                if (getCachevalue("patientData")) {
                                    this.props.changeScreen()
                                    history.push({ pathname: '/OPHome/PatientDetails/Billing' })
                                    this.setState({
                                        MainTabIndex: 1.2,
                                        SelectedItem: this.state.List.filter((item) => item.id == 1.2)[0],
                                    }, () => {
                                        setTimeout(() => {
                                            this.setState({
                                                SubTabIndex: 1.23,
                                                SelectedSubItem: this.state.SelectedItem.subMenu.filter((item) => item.id == 1.23)[0]
                                            })
                                        }, 500)
                                    })
                                } else {
                                    this.props.changeScreen()
                                    history.push({ pathname: '/IPHome/PatientDetails/ServiceBilling' })
                                    this.setState({
                                        MainTabIndex: 6.2,
                                        SelectedItem: this.state.List.filter((item) => item.id == 6.2)[0],
                                    }, () => {
                                        setTimeout(() => {
                                            this.setState({
                                                SubTabIndex: 6.23,
                                                SelectedSubItem: this.state.SelectedItem.subMenu.filter((item) => item.id == 6.23)[0]
                                            })
                                        }, 500)
                                    })
                                }
                            } else {
                                clearCachevalue("RadCancelBillData");
                                clearCachevalue("isForCancelBill");
                                clearCachevalue('RadPatientData')
                                clearCachevalue('IsFromIPBill')
                                clearCachevalue('IsFromOPBill')
                                history.push({ pathname: '/BillingTransaction/OverAllBills' })
                            }
                        } else {
                            let CancelBillData = JSON.parse(getCachevalue("RadCancelBillData"))
                            if (CancelBillData?.FromBills) {
                                clearCachevalue("RadCancelBillData");
                                clearCachevalue("isForCancelBill");
                                history.push({ state: { billSummaryId: '', fromModifyBill: false, fromCancelBill: false } })
                                this.props.changeScreen()
                                this.setState({
                                    MainTabIndex: 45.2,
                                    SelectedItem: this.state.List.filter((item) => item.id == 45.2)[0],
                                }, () => {
                                    setTimeout(() => {
                                        this.setState({
                                            SubTabIndex: 45.23,
                                            SelectedSubItem: this.state.SelectedItem.subMenu.filter((item) => item.id == 45.23)[0]
                                        })
                                    }, 500)
                                })
                            } else {
                                clearCachevalue("RadCancelBillData");
                                clearCachevalue("isForCancelBill");
                                clearCachevalue('RadPatientData')
                                clearCachevalue('IsFromIPBill')
                                clearCachevalue('IsFromOPBill')
                                history.push({ pathname: '/RadiologyBillingTransaction/OverallBills', state: { fromModifyBill: false, billSummaryId: '', fromCancelBill: false } })
                            }
                        }

                    }
                }}
            >{this.returnBackButtonName()}</Button>
        )
    }

    render() {
        let { history } = this.props
        return (
            <div>
                <div className='eMed_tabWrapper'>
                    {
                        this.state.BackScreen === null ? null :
                            <div>
                                <Tooltip title="Back" placement='top' arrow>
                                    <IconButton
                                        disabled={(getCachevalue("isForCancelBill") === "true") || (getCachevalue("isForVisitreport") === "true") || (getCachevalue("IsForCheckedOut") === "true") || (getCachevalue("IsPORequestEdit") === "true") || (getCachevalue("isCanteenOverall") === "true") || (getCachevalue("DisableAllActions") === "true")}
                                        emed_tid="back_button"
                                        onClick={() => {
                                            history.push({ pathname: `${this.state.BackScreen}` })
                                            if (this.state.BackScreen !== "/IPHome/Demographics/AdmissionHistory") {
                                                clearCachevalue("patientData");
                                                clearCachevalue("IppatientData");
                                                clearCachevalue("OP_CreateAppointment_PatientId");
                                                clearCachevalue("OTpatientData");
                                                clearCachevalue("AppRequestPatientData");
                                                clearCachevalue("DoctorPatientData")
                                                clearCachevalue("CurrentDoctorPatientData")
                                                clearCachevalue('updatePatient')
                                                clearCachevalue('RadPatientData')
                                                clearCachevalue('QRRequestPatientData')
                                                clearCachevalue('IsFromIPBill')
                                                clearCachevalue('IsFromOPBill')
                                                clearCachevalue('reservePatientData')
                                                clearCachevalue('provisional_diagnosis')
                                                clearCachevalue('OP_CreateAppointment_PatientId')
                                                clearCachevalue('BillType')
                                                clearCachevalue('FromOtherScreen')
                                            }
                                            clearCachevalue("withoutAppointment");
                                            if (this.state.loginInfo?.module_name === 'front_office' && this.props.nurseState) {
                                                this.props.changeNurse(false)
                                            }
                                        }}>
                                        <ChevronLeftIcon color={(getCachevalue("isForCancelBill") === "true") || (getCachevalue("isForVisitreport") === "true") || (getCachevalue("IsForCheckedOut") === "true") || (getCachevalue("IsPORequestEdit") === "true") || (getCachevalue("isCanteenOverall") === "true") ? "grey" : 'primary'} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                    }
                    <div >
                        {/* <Box> */}
                        <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} width={"90vw"}>
                            <Tabs
                                value={this.state.MainTabIndex}
                                onChange={this.handleChange}
                                variant="scrollable"
                                scrollButtons={'auto'}
                                sx={{ minHeight: '1vw' }}
                            >
                                {this.state.List && this.state.List.length > 0 && this.state.List.map((data, index) => {
                                    if (this.checkAccess(data)) {
                                        return (
                                            <Tab sx={{ textTransform: 'capitalize', minHeight: '1vw', fontWeight: 600 }}
                                                key={data.id}
                                                value={data.id}
                                                label={
                                                    ((data.menuName === 'Inbound' || data.menuName === 'Outbound') && data?.count != 0 && this.state.loginInfo?.module_name === 'Pharmacy') ?
                                                        <Box sx={{ display: 'flex', flexDirection: 'row', fontSize: '.85vw' }}>
                                                            {data.menuName} <span style={{
                                                                backgroundColor: '#D32F2F', border: '1px solid #D32F2F', borderRadius: '12px', padding: '2px',
                                                                color: '#FFFFFF', display: 'inline-block', minWidth: '20px', textAlign: 'center', fontSize: '.7vw', marginLeft: '.2vw'
                                                            }}>
                                                                {data?.count}
                                                            </span>
                                                        </Box> :
                                                        <Box sx={{ display: 'flex', flexDirection: 'row', fontSize: '.85vw' }}>{data.menuName}</Box>
                                                }
                                                emed_tid={data.testID || `common_tabs_main_tab_${data.id}`}
                                                disabled={getCachevalue("isForCancelBill") === "true" || (getCachevalue("isForVisitreport") === "true") || (getCachevalue("IsForCheckedOut") === "true") || (getCachevalue("IsPORequestEdit") === "true") || (getCachevalue("isCanteenOverall") === "true") || (getCachevalue("isInRadiologyBilling") === "true") || (getCachevalue("DisableAllActions") === "true")} />

                                        )
                                    }
                                }
                                )}
                            </Tabs>
                            {this.state?.List[0]?.menuName === "Quick Billing & Appointment" || this.state?.List[0]?.menuName === "Quick Billing" || this.state?.List[1]?.menuName === "Create Appointment" ?
                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <Box width={"50dvw"} display={Object.keys(this.props?.VisitDateBalAmount ? this.props?.VisitDateBalAmount : {})?.length > 0 ? 'flex' : "none"} justifyContent={"flex-end"} marginRight={"0.625dvw"}>
                                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: "0.5vw" }}>
                                            <Typography fontSize={"0.9vw"}>Previous Credit Balance : </Typography>
                                            <Typography fontSize={"0.9vw"} fontWeight={600} marginLeft={"0.3vw"}>{AmountFormat(this.props?.VisitDateBalAmount?.total_outstanding || 0)}</Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: "1.5vw" }}>
                                            <Typography fontSize={"0.9vw"}>Previous Advance Balance : </Typography>
                                            <Typography fontSize={"0.9vw"} fontWeight={600} marginLeft={"0.3vw"}>{AmountFormat(this.props?.VisitDateBalAmount?.advance_balance || 0)}</Typography>
                                        </Box>
                                    </Box>
                                    <FormControlLabel checked={this.props.nurseState} control={<Checkbox emed_tid="common_tabs_nurse_checkbox" />} onClick={(e) => {
                                        this.props.changeNurse(e.target.checked)
                                    }} label="Nurse" />
                                </Box> : null}
                            {(this.state.SelectedItem?.menuName === "In Patient List" || window.location.pathname === "/IPHome/Reservation") ?
                                <Box sx={{ position: "relative", top: "0.4vw", width: "13vw" }}>
                                    <CommonDatePicker
                                        FromDate={this.props.dateDetails?.fromDate}
                                        ToDate={this.props.dateDetails?.toDate}
                                        DateIndex={this.props.dateDetails?.dateIndex}
                                        SelectedDates={this.FilterDate.bind(this)}
                                        HideAllMenu={true}
                                        HideDate={true}
                                        Future={true}
                                        AllowAllDate={true} />
                                </Box> : null}
                            {(getCachevalue("isForCancelBill") === "true" && (getCachevalue("LabCancelBilldata") || ((getCachevalue("RadCancelBillData")) && JSON.parse(localGetItem("loggedInUserInfo"))?.module_name === "front_office"))) ? this.CancellBackButton() : null}
                            {getCachevalue("isForVisitreport") === "true" ?
                                <Button
                                    startIcon={<ChevronLeftIcon />}
                                    size='small'
                                    variant='contained'
                                    sx={{ textTransform: 'capitalize', }}
                                    onClick={() => {
                                        clearCachevalue("isForVisitreport");
                                        this.props.history.push({ pathname: "/DoctorHome/Reports/DoctorVisit" })
                                    }}
                                    emed_tid="common_tabs_back_to_visit_report_btn"
                                >Back to Visit Report</Button> : null}
                            {(getCachevalue("IsForCheckedOut") === "true") ? <Button
                                startIcon={<ChevronLeftIcon />}
                                size='small'
                                variant='contained'
                                sx={{ textTransform: 'capitalize', }}
                                onClick={() => {
                                    clearCachevalue("IsForCheckedOut");
                                    clearCachevalue('IppatientData')
                                    this.props.history.push({ pathname: "/IPHome" })
                                }}
                                emed_tid="common_tabs_back_to_checkout_btn"
                            >Back to Checkout</Button> : null}
                            {(getCachevalue("IsPORequestEdit") === "true") ? <Button
                                startIcon={<ChevronLeftIcon />}
                                size='small'
                                variant='contained'
                                sx={{ textTransform: 'capitalize', }}
                                onClick={() => {
                                    clearCachevalue("IsPORequestEdit");
                                    this.props.history.push({ pathname: "/PharmacyPurchase/PurchaseRequest" })
                                }}
                                emed_tid="common_tabs_back_to_po_request_btn"
                            >Back to PO Request</Button> : null}
                            {(getCachevalue("isCanteenOverall") === "true") ? <Button
                                startIcon={<ChevronLeftIcon />}
                                size='small'
                                variant='contained'
                                sx={{ textTransform: 'capitalize', }}
                                onClick={() => {
                                    clearCachevalue("isCanteenOverall")
                                    this.props.history.push({ pathname: "/CanteenBillingTransaction" })
                                }}
                                emed_tid="common_tabs_back_to_overall_bill_btn"
                            >Back to Overall Bill</Button> : null}
                        </Box>
                        {/* </Box> */}
                    </div>
                </div>

                <div>
                    {
                        Object.keys(this.state.SelectedItem || {}).length !== 0 ?
                            this.state.SelectedItem.subMenu?.length === 0 ?
                                <div className='eMed_MainComponentDiv'>
                                    {this.renderMainComponent(this.state.SelectedItem, "Tab")}
                                </div>
                                :
                                <div>
                                    {
                                        this.state.SubTabIndex != 0 ?
                                            <div>
                                                <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                                    <Tabs
                                                        value={this.state.SubTabIndex}
                                                        onChange={this.handleChangesub}
                                                        variant="scrollable"
                                                        scrollButtons={"auto"}
                                                        sx={{ minHeight: '1vw' }}
                                                    >
                                                        {
                                                            this.state.SelectedItem?.subMenu?.map((data, index) => {
                                                                // if(this.SubTabcheckAccess(data)){
                                                                let ipPatientData = getCachevalue("IppatientData")
                                                                let patientData = JSON.parse(ipPatientData)
                                                                return (
                                                                    <Tab sx={{ textTransform: 'capitalize', minHeight: '1vw', fontWeight: 600 }} disabled={(getCachevalue('RadCancelBill') && data?.id !== 45.21) || (getCachevalue("isForCancelBill") === "true") ? true : false} key={data.id} value={data.id} label={data.menuName} emed_tid={data.testID || `common_tabs_sub_tab_${data.id}`} />
                                                                )
                                                                // }

                                                            })
                                                        }
                                                    </Tabs>
                                                    {(this.state.SubTabIndex == 1.21 || this.state.SubTabIndex == 6.21) ?
                                                        <Box sx={{ display: 'flex', alignItems: "center", gap: '1vw' }}>
                                                            {(this.state.isBillDoctor && this.state.SubTabIndex == 6.21) ?
                                                                <Autocomplete
                                                                    options={this.state.ConsultantDataList}
                                                                    disableClearable
                                                                    getOptionLabel={(options) => typeof (options) === 'string' ? options : (options.doctor_name ? options.doctor_name : null)}
                                                                    onChange={(e, value) => {
                                                                        this.setState({ consultantName: value })
                                                                        setCachevalue(value?.doctor_id, "bill_doctor_id")
                                                                    }}
                                                                    disabled={(this.state.forcancel && !JSON.parse(getCachevalue("IPCancelBilldata"))?.isForEditBill) ? true : false}
                                                                    value={this.state.consultantName || null}
                                                                    size="small"
                                                                    sx={{ width: "12vw", marginTop: '0.5vh', marginLeft: this.state.forcancel ? '47dvw' : 0 }}
                                                                    renderInput={(params) => <TextField {...params} label={'Billed Doctor'} InputProps={{ ...params.InputProps, sx: { height: '4vh' } }} emed_tid="common_tabs_billed_doctor_autocomplete" />}
                                                                    renderOption={(props, option) => (
                                                                        <li {...props} key={option?.id}>
                                                                            <Typography fontSize={'0.9vw'}>{option.doctor_name}</Typography>
                                                                        </li>
                                                                    )}
                                                                />
                                                                : null}
                                                            {!this.state.forcancel ?
                                                                <Box sx={{ display: 'flex', gap: '1vw' }}>
                                                                    <Button
                                                                        disabled={
                                                                            !(window.location.pathname === "/OPHome/PatientDetails/Billing" ? CheckAccessFunc("front_office", "Home", "Billing", "Create Bill", "SubTab")?.editAccess :
                                                                                window.location.pathname === "/IPHome/PatientDetails/ServiceBilling" ? CheckAccessFunc("front_office", "In Patients", "Service Billing", "Create Bill", "SubTab")?.editAccess :
                                                                                    CheckAccessFunc('front_office', 'Billing', 'Laboratory Billing', null, 'Tab')?.editAccess)}
                                                                        sx={{ width: '10vw', textTransform: 'capitalize', height: '2vw' }} variant='contained' size='small' onClick={() => {
                                                                            if (this.state?.List[1]?.menuName === "Billing") {
                                                                                setCachevalue(true, 'isInRadiologyBilling')
                                                                                let patientDatas = getCachevalue("patientData")
                                                                                let patients = JSON.parse(patientDatas)
                                                                                this.props.history.push({ pathname: "/Billing", state: { patientData: patients } })
                                                                            } else if (this.state?.List[1]?.menuName === "Service Billing") {
                                                                                let patientDatas = getCachevalue("IppatientData")
                                                                                let IPpatients = JSON.parse(patientDatas)
                                                                                setCachevalue(true, 'isInRadiologyBilling')
                                                                                this.props.history.push({ pathname: "/Billing", state: { IP_patientData: IPpatients } })
                                                                            }
                                                                        }}
                                                                        emed_tid="common_tabs_laboratory_btn">{"laboratory"}</Button>
                                                                    {localGetItem("Show_Radiology_Bills_In_FO") === "true" ?
                                                                        <Button
                                                                            disabled={
                                                                                !(window.location.pathname === "/OPHome/PatientDetails/Billing" ? CheckAccessFunc("front_office", "Home", "Billing", "Create Bill", "SubTab")?.editAccess :
                                                                                    window.location.pathname === "/IPHome/PatientDetails/ServiceBilling" ? CheckAccessFunc("front_office", "In Patients", "Service Billing", "Create Bill", "SubTab")?.editAccess :
                                                                                        CheckAccessFunc('front_office', 'Billing', 'Radiology Billing', null, 'Tab')?.editAccess)}
                                                                            sx={{ width: '10dvw', textTransform: 'capitalize', height: '2dvw' }} variant='contained' size='small' onClick={() => {
                                                                                if (this.state?.List[1]?.menuName === "Billing") {
                                                                                    let patientDatas = getCachevalue("patientData")
                                                                                    let patients = JSON.parse(patientDatas)
                                                                            setCachevalue(true, 'isInRadiologyBilling')
                                                                            this.props.history.push({ pathname: "/Billing/RadiologyBilling", state: { BillFromOP: true, patientData: patients } })
                                                                        } else if (this.state?.List[1]?.menuName === "Service Billing") {
                                                                            let patientDatas = getCachevalue("IppatientData")
                                                                            let IPpatients = JSON.parse(patientDatas)
                                                                            setCachevalue(true, 'isInRadiologyBilling')
                                                                            this.props.history.push({ pathname: "/Billing/RadiologyBilling", state: { BillFromIP: true, patientData: IPpatients } })
                                                                        }
                                                                    }}
                                                                    emed_tid="common_tabs_radiology_btn">{"Radiology"}</Button> : null}
                                                                    {(localGetItem("enable_multibilling") === "true" && localGetItem("isNewBilling") === "false") ? 
                                                                    <Button sx={{ width: '10dvw', textTransform: 'capitalize', height: '2dvw' }} variant='contained' size='small'
                                                                            disabled={
                                                                                !(window.location.pathname === "/OPHome/PatientDetails/Billing" ? CheckAccessFunc("front_office", "Home", "Billing", "Create Bill", "SubTab")?.editAccess :
                                                                                    window.location.pathname === "/IPHome/PatientDetails/ServiceBilling" ? CheckAccessFunc("front_office", "In Patients", "Service Billing", "Create Bill", "SubTab")?.editAccess :
                                                                                        CheckAccessFunc("front_office", "Billing", 'Multi Billing', null, "Tab")?.editAccess)}
                                                                        onClick={() => {
                                                                            if (this.state?.List[1]?.menuName === "Billing") {
                                                                                let patientDatas = getCachevalue("patientData")
                                                                                let patients = JSON.parse(patientDatas)
                                                                                setCachevalue(true, 'isInRadiologyBilling')
                                                                                this.props.history.push({ pathname: "/Billing/MultiBilling", state: { service_number: patients?.op_number } })
                                                                            } else if (this.state?.List[1]?.menuName === "Service Billing") {
                                                                                let patientDatas = getCachevalue("IppatientData")
                                                                                let patients = JSON.parse(patientDatas)
                                                                                setCachevalue(true, 'isInRadiologyBilling')
                                                                                this.props.history.push({ pathname: "/Billing/MultiBilling", state: { service_number: patients?.ip_number } })
                                                                            }
                                                                        }}
                                                                        emed_tid="common_tabs_multi_billing_btn">{"Multi Billing"}</Button> : null}
                                                                </Box> : null}
                                                        </Box>
                                                        : null}
                                                    {(getCachevalue("isForCancelBill") === "true") ? this.CancellBackButton() : null}
                                                </Box>
                                                <div className='eMed_SubComponentDiv'>
                                                    {this.renderMainComponent(this.state.SelectedSubItem, "SubTab")}
                                                </div>
                                            </div> : null
                                    }
                                </div>
                            : null
                    }
                </div>
            </div>
        )
    }
}
